var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { createContext, useContext, useState, } from 'react';
var SearchContext = createContext(undefined);
// Hook for functional components
export var useSearchContext = function () {
    var context = useContext(SearchContext);
    if (!context) {
        throw new Error('useSearchContext must be used within SearchProvider');
    }
    return context;
};
// HOC wrapper for class components
export var withSearchContext = function (Component) {
    var WrappedComponent = React.forwardRef(function (props, ref) {
        var searchContext = useSearchContext();
        return React.createElement(Component, __assign({}, props, searchContext, { ref: ref }));
    });
    WrappedComponent.displayName = "withSearchContext(".concat(Component.displayName || Component.name, ")");
    return WrappedComponent;
};
// Provider component
export var SearchProvider = function (_a) {
    var children = _a.children;
    var _b = useState(''), searchTerm = _b[0], setSearchTerm = _b[1];
    var _c = useState(''), origSearchTerm = _c[0], setOrigSearchTerm = _c[1];
    var _d = useState({ spelling_suggestion: '', url: '' }), spellingSuggestion = _d[0], setSpellingSuggestion = _d[1];
    var _e = useState('0'), activeZone = _e[0], setActiveZone = _e[1];
    var _f = useState([]), filteredAttrs = _f[0], setFilteredAttrs = _f[1];
    var _g = useState({}), filteredAttrValues = _g[0], setFilteredAttrValues = _g[1];
    return (React.createElement(SearchContext.Provider, { value: {
            searchTerm: searchTerm,
            origSearchTerm: origSearchTerm,
            spellingSuggestion: spellingSuggestion,
            activeZone: activeZone,
            filteredAttrs: filteredAttrs,
            filteredAttrValues: filteredAttrValues,
            setSearchTerm: setSearchTerm,
            setOrigSearchTerm: setOrigSearchTerm,
            setSpellingSuggestion: setSpellingSuggestion,
            setActiveZone: setActiveZone,
            setFilteredAttrs: setFilteredAttrs,
            setFilteredAttrValues: setFilteredAttrValues,
        } }, children));
};
